import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ['loader', 'success'];

  connect() {
    let stimulus = this;

    consumer.subscriptions.create("EndpointVerificationChannel",
      {
        received(data) {
          if (data.action == 'authentication_success') {
            stimulus.loaderTarget.style.display = "none";
            stimulus.successTarget.classList.remove("d-none");

            setTimeout(function() {
              location.reload();
            }, 2000);
          }
        }
      }
    )
  }
}